import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ConfigurationDataService } from '../configuration-data.service';
import { SharedDataService } from '../shared-data.service';
import { MenuItem } from 'primeng/primeng';

import { Module } from './module';

class ModMenuItem {
  name: string;
  link: string;
  descr: string;
}

@Injectable()
export class ModuleService {

  headers = new HttpHeaders({
    'Content-Type': 'application/json'
  });

  constructor(private http: HttpClient, private config: ConfigurationDataService, private shared: SharedDataService) { }

  /**
   * Loads all enabled modules into shared data
   */
  public loadEnabledModules(): any {
    this.http.post(this.config.moduleURL + "allowed/control", JSON.stringify(this.shared.getTokenAuthData()), { headers: this.headers }).subscribe(
      (modList : any) => {
        let menuItems: MenuItem[] = [];
        for (var mod of modList) {
          let item: MenuItem = {};
          item.label = mod.name;
          item.routerLink = [mod.link];
          menuItems.push(item);
        }
        this.shared.setMainMenuItems(menuItems);
      }
    );
  }

  /**
   * Loads all enabled modules into shared data
   */
  public loadAvailableModules(): any {
    return this.http.post(this.config.moduleURL + "available",
      JSON.stringify(this.shared.getTokenAuthData()), { headers: this.headers });
  }

  public saveModuleListActiveState(pModules: Module[]): any {
    console.log('Push article to insert method of service.');
    var params: any = {};
    params.credentials = this.shared.getTokenAuthData();
    params.list = pModules;
    console.log(JSON.stringify(params));
    return this.http.post(this.config.moduleURL + "list/activestate", JSON.stringify(params),
      { headers: this.headers })
      ;
  }
}



// WEBPACK FOOTER //
// /home/pneuser/workspace/pepelogistic/pepeLogisticControl/src/app/login/module.service.ts